import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-tags',
  storeModule.createStoreModule('real-estate-developments-tags')
)
